import { getAccountKeyForMailboxInfo, type MailboxInfo } from 'owa-client-types';
import type { OutlookCloudPolicyData } from '../store/schema/OutlookCloudPoliciesSchema';
import type { OutlookCloudPolicySettingId } from '../store/schema/OutlookCloudPolicyTypes';
import getStore from '../store/store';
import { settingIdToFeature } from '../utils/featureSettingIds';

export function getPolicyDataBySettingId(
    mailboxInfo: MailboxInfo,
    settingId: OutlookCloudPolicySettingId
): OutlookCloudPolicyData | undefined {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    const feature = settingIdToFeature[settingId];
    return getStore().get(accountKey)?.policies[feature]?.[settingId];
}
